import deleteImageState from '../actions/deleteImageState';
import type InlineImageViewState from '../schema/InlineImageViewState';
import ImageStatus from '../schema/ImageStatus';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import { INSERT_INLINEIMAGE_CHANGE_SOURCE } from './constants';

export default async function onImageError(
    viewState: InlineImageViewState,
    editorViewState: EditorViewState,
    temporaryId: string
) {
    const operateContent = await lazyOperateContent.import();

    const entry = viewState.imageStatusMap[temporaryId];
    if (entry?.status == ImageStatus.PlaceholderShown) {
        // If placeholder has been inserted
        const sourceElement = entry.placeholder;
        if (sourceElement) {
            operateContent(editorViewState, (editor, range, domApi) => {
                // If placeholder is found. remove it on error.
                editor.addUndoSnapshot(
                    () => editor.deleteNode(sourceElement),
                    INSERT_INLINEIMAGE_CHANGE_SOURCE
                );
                return range;
            });
        }
    }

    deleteImageState(viewState, temporaryId);
}
